<template>
    <div>
        <Pane title="重新提交设计评审" :showRemarks="false">
            <template>重新发起设计评审流程</template>
        </Pane>

        <div class="container">
            <a-skeleton :loading="loading" :paragraph="{ rows: 8 }">
                <a-form
                    :form="form"
                    :label-col="{ span: 6 }"
                    :wrapper-col="{ span: 16 }"
                    :colon="false"
                >
                    <a-row :gutter="16">
                        <a-col :span="12">
                            <a-form-item label="工程名称">
                                <a-input v-decorator="['projectName']" disabled />
                            </a-form-item>
                        </a-col>
                        <!--                        <a-col :span="12">-->
                        <!--                            <a-form-item label="项目编码">-->
                        <!--                                <a-input v-decorator="['projectCode']" disabled />-->
                        <!--                            </a-form-item>-->
                        <!--                        </a-col>-->
                        <a-col :span="12">
                            <a-form-item label="设计编号">
                                <a-input v-decorator="['designNo']" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="项目阶段">
                                <a-select v-decorator="['phaseCode']" disabled>
                                    <a-select-option v-for="item in designPhaseList" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="管理级别">
                                <a-radio-group v-decorator="['manageLevel']" disabled>
                                    <a-radio-button v-for="item in manageLevelList" :key="item.value" :value="item.value">{{ item.name }}</a-radio-button>
                                </a-radio-group>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="项目类别">
                                <a-radio-group v-decorator="['prjCategory']" disabled>
                                    <a-radio-button v-for="item in prjCategoryList" :key="item.value" :value="item.value">{{ item.name }}</a-radio-button>
                                </a-radio-group>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="是否需要评审">
                                <a-radio-group v-decorator="['needReview']">
                                    <a-radio :value="true">是</a-radio>
                                    <a-radio :value="false">否</a-radio>
                                </a-radio-group>
                            </a-form-item>
                        </a-col>

                        <a-col :span="12">
                            <a-form-item label="生产部门">
                                <a-select
                                    show-search
                                    :filter-option="$selectFilterOption"
                                    v-decorator="['prodDeptId']"
                                    placeholder="请选择生产部门"
                                >
                                    <a-select-option v-for="item in organizationList" :key="item.id" :value="item.id">{{ item.uniqueName }}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="项目负责人">
                                <a-select
                                    mode="multiple"
                                    show-search
                                    :filter-option="$selectFilterOption"
                                    placeholder="请选择项目负责人"
                                    :value="prjLeaderIdArr"
                                    @change="handlePrjLeaderChange"
                                >
                                    <a-select-option v-for="item in prjLeaderOptions" :key="item.userId" :value="item.userId">{{ item.name }}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="主持人">
                                <a-select
                                    show-search
                                    :filter-option="$selectFilterOption"
                                    :value="hostEmployee.userId || undefined"
                                    placeholder="请选择主持人"
                                    @change="handleHostSelect"
                                >
                                    <a-select-option v-for="item in hostOptions" :key="item.userId" :value="item.userId">{{ item.name }}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="记录人">
                                <a-select
                                    show-search
                                    :filter-option="$selectFilterOption"
                                    placeholder="请选择记录人"
                                    :value="recorderId || undefined"
                                    @change="handleRecorderSelect"
                                >
                                    <a-select-option v-for="item in allPersonnelOptions" :key="item.userId" :value="item.userId">{{ item.name }}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="参会人员">
                                <a-select
                                    mode="multiple"
                                    show-search
                                    :filter-option="$selectFilterOption"
                                    placeholder="请选择参会人员"
                                    :value="attendeeIds"
                                    @change="handleAttendeeSelect"
                                >
                                    <a-select-option v-for="item in allPersonnelOptions" :key="item.userId" :value="item.userId">{{ item.name }}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="专业负责人">
                                <EmployeeSelector
                                    disabled
                                    multiple
                                    @change="handleMajorLeaderChange"
                                    :value="majorLeaderList"
                                >
                                    <a-button block style="text-align: left">{{ majorLeaderList.length ? majorLeaderList.map(i => i.name).join(',') : '请选择专业负责人' }}</a-button>
                                </EmployeeSelector>
                            </a-form-item>
                        </a-col>
                        <a-col :span="24">
                            <a-form-item :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }" label="评审内容">
                                <a-textarea v-decorator="['reviewContent']" :rows="4" placeholder="请输入评审内容" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="24">
                            <a-form-item :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }" label="附件">
                                <Attachment :editable="true" :fileList="fileList" @change="fileList = $event" />
                            </a-form-item>
                        </a-col>
                    </a-row>

                    <div class="center">
                        <a-space>
                            <a-button type="primary" @click="submitReview" :loading="submitting">
                                重新提交
                            </a-button>
                            <a-button @click="goBack">返回</a-button>
                        </a-space>
                    </div>
                </a-form>
            </a-skeleton>
        </div>
    </div>
</template>

<script>
import { fetchDesignReviewDetail, resubmitDesignReview } from "@/api/project-execute/review";
import { mapMutations, mapGetters, mapState } from "vuex";
import EmployeeSelector from "@/components/employee-selector";
import Attachment from "@/components/attachment";
import { parseAttachment, buildAttachmentData } from '@/utils/attachment'
import organization from "@/mixins/organization";
import { getDesignPlanPersonnel, fetchSimplePlanPersonnel } from '@/api/personnel'
import { fetchDesignPlanVersionInfo } from '@/api/project-plan/plan'
import { getPersonnel } from '@/api/project-approval/review'

export default {
    name: "DesignReviewReapply",
    mixins: [organization],
    components: { EmployeeSelector, Attachment },
    data() {
        return {
            form: this.$form.createForm(this),
            loading: false,
            submitting: false,
            id: "",
            phaseId: "",
            taskId: "",
            instanceId: "",
            prjLeaderList: [],
            prjLeaderIdArr: [],
            prjLeaderOptions: [],
            hostEmployee: {},
            hostOptions: [],
            recorderId: "",
            recorderName: "",
            attendeeIds: [],
            attendeeNames: "",
            allPersonnelOptions: [],
            majorLeaderList: [],
            fileList: [],
        };
    },
    computed: {
        ...mapState("approval", ["detail"]),
        ...mapGetters("setting", ["findDataDict"]),
        manageLevelList() {
            return this.findDataDict("cosys.manageLevel") || [];
        },
        prjCategoryList() {
            return this.findDataDict("cosys.prjCategory") || [];
        },
        designPhaseList() {
            return this.findDataDict("cosys.designPhase") || [];
        },
    },
    mounted() {
        const { taskId, instanceId } = this.$route.query;
        this.taskId = taskId || "";
        this.instanceId = instanceId || "";

        const routeId = this.$route.params.id;
        if (routeId) {
            this.id = routeId;
        } else {
            const { businessKey } = this.$route.query;
            if (businessKey) {
                const parts = businessKey.split(":");
                this.id = parts.length > 1 ? parts[1] : "";
            }
        }

        if (this.id) {
            this.fetchDetail(this.id);
        }
        if (this.taskId && this.instanceId) {
            this.setTaskId(this.taskId);
            this.setInstanceId(this.instanceId);
        }
    },
    methods: {
        ...mapMutations("approval", ["setTaskId", "setInstanceId"]),
        fetchDetail(id) {
            this.loading = true;
            fetchDesignReviewDetail(id)
                .then((data) => {
                    if (!data) return;
                    this.phaseId = data.phaseId || "";
                    this.$nextTick(() => {
                        setTimeout(() => {
                            this.form.setFieldsValue({
                                projectName: data.projectName || "",
                                designNo: data.designNo || "",
                                phaseCode: data.phaseCode || "",
                                manageLevel: data.manageLevel || "",
                                prjCategory: data.prjCategory || "",
                                needReview: data.needReview ?? true,
                                prodDeptId: data.prodDeptId || undefined,
                                reviewContent: data.reviewContent || "",
                            });
                        });
                    });
                    if (data.prjLeaderId && data.prjLeaderName) {
                        const names = (data.prjLeaderName || '').split(',').filter(Boolean);
                        const ids = (data.prjLeaderId || '').split(',').filter(Boolean);
                        this.prjLeaderList = names.map((name, i) => ({ name, userId: ids[i] || '' }));
                        this.prjLeaderOptions = this.prjLeaderList.map(i => ({ ...i }));
                        this.prjLeaderIdArr = this.prjLeaderList.map(i => i.userId).filter(Boolean);
                    }
                    if (data.hostId && data.hostName) {
                        this.hostEmployee = { userId: data.hostId, name: data.hostName };
                    }
                    if (data.recorderId && data.recorderName) {
                        this.recorderId = data.recorderId;
                        this.recorderName = data.recorderName;
                    }
                    if (data.attendeeNames) {
                        const names = (data.attendeeNames || '').split(',').filter(Boolean);
                        const ids = (data.attendeeIds || '').split(',').filter(Boolean);
                        this.attendeeIds = ids.length ? ids : names;
                    } else {
                        this.attendeeIds = [];
                    }
                    if (data.majorLeaderNames) {
                        const names = (data.majorLeaderNames || '').split(',').filter(Boolean);
                        const ids = (data.majorLeaderIds || '').split(',').filter(Boolean);
                        this.majorLeaderList = names.map((name, i) => ({ name, userId: ids[i] || '' }));
                    }
                    this.fileList = parseAttachment(data.attachment, data.attachmentPaths);

                    if (this.phaseId) {
                        this.loadPersonnel(this.phaseId);
                    }
                    this.fetchHostOptions(data.prodDeptId, data.manageLevel)
                })
                .catch(() => {
                    this.$message.error("获取设计评审详情失败");
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handlePrjLeaderChange(ids) {
            const selectedIds = ids || [];
            this.prjLeaderIdArr = selectedIds;
            const selectedList = selectedIds.map(id => {
                const found = this.prjLeaderOptions.find(i => i.userId === id);
                return found || { userId: id, name: id };
            });
            this.prjLeaderList = selectedList;
        },
        handleHostSelect(userId) {
            if (userId) {
                const found = this.hostOptions.find(p => p.userId === userId);
                this.hostEmployee = { userId, name: found ? found.name : '' };
            } else {
                this.hostEmployee = {};
            }
        },
        handleRecorderSelect(userId) {
            if (userId) {
                const found = this.allPersonnelOptions.find(p => p.userId === userId);
                this.recorderId = userId;
                this.recorderName = found ? found.name : '';
            } else {
                this.recorderId = '';
                this.recorderName = '';
            }
        },
        handleAttendeeSelect(userIds) {
            this.attendeeIds = userIds || [];
            const names = (userIds || []).map(id => {
                const found = this.allPersonnelOptions.find(p => p.userId === id);
                return found ? found.name : '';
            }).filter(Boolean);
            this.attendeeNames = names.join(',');
        },
        handleMajorLeaderChange(arr) {
            this.majorLeaderList = arr;
        },
        async fetchHostOptions(orgId, manageLevel) {
            if (!orgId) return;
            try {
                const normalize = items => (items || []).map(item => ({ ...item, userId: item.userId || item.id }));
                const res = await getPersonnel(orgId);
                this.hostOptions = manageLevel === 'company'
                    ? normalize(res.deptChiefEngineers)
                    : normalize(res.masters);
                if (this.hostEmployee.userId && this.hostEmployee.name) {
                    if (!this.hostOptions.find(p => p.userId === this.hostEmployee.userId)) {
                        this.hostOptions.push({ userId: this.hostEmployee.userId, name: this.hostEmployee.name });
                    }
                }
            } catch (e) {
                console.error('获取部门分管负责人失败', e);
            }
        },
        async loadPersonnel(phaseId) {
            if (!phaseId) return;
            try {
                const versionInfo = await fetchDesignPlanVersionInfo(phaseId);
                const plan = versionInfo?.currentPlan || versionInfo?.currentSimplePlan;
                const isSimple = plan && plan.prjCategory === 'simple';
                if (plan) {
                    this.$nextTick(() => {
                        this.form.setFieldsValue({ prjCategory: plan.prjCategory || '' });
                    });
                }
                const params = { phaseId };
                const res = isSimple ? await fetchSimplePlanPersonnel(params) : await getDesignPlanPersonnel(params);
                if (!res) return;

                const allPersonnelMap = new Map();
                const mergePersonnel = (ids, names) => {
                    if (!ids || !names) return;
                    const idArr = ids.split(',').filter(Boolean);
                    const nameArr = names.split(',').filter(Boolean);
                    idArr.forEach((id, i) => {
                        if (!allPersonnelMap.has(id)) {
                            allPersonnelMap.set(id, { userId: id, name: nameArr[i] || '' });
                        }
                    });
                };

                if (res.projectPersonnel) {
                    const pp = res.projectPersonnel;
                    mergePersonnel(pp.prjLeaderId, pp.prjLeaderName);
                    mergePersonnel(pp.chiefEngineerId, pp.chiefEngineerName);
                    mergePersonnel(pp.deptLeaderId, pp.deptLeaderName);
                    mergePersonnel(pp.generalEngineerId, pp.generalEngineerName);
                    mergePersonnel(pp.approverId, pp.approverName);
                    mergePersonnel(pp.companyLeaderId, pp.companyLeaderName);
                }

                if (res.majorPersonnels) {
                    res.majorPersonnels.forEach(m => {
                        mergePersonnel(m.majorLeaderIds, m.majorLeaderNames);
                        mergePersonnel(m.designerIds, m.designerNames);
                        mergePersonnel(m.reviewerIds, m.reviewerNames);
                        mergePersonnel(m.auditorIds, m.auditorNames);
                        mergePersonnel(m.approverIds, m.approverNames);
                    });
                }

                this.allPersonnelOptions = Array.from(allPersonnelMap.values());
            } catch (e) {
                console.error('获取人员失败', e);
            }
        },
        submitReview() {
            this.form.validateFields((err, formValues) => {
                if (err) return;

                this.submitting = true;
                const params = {
                    id: this.id,
                    phaseId: this.phaseId,
                    ...formValues,
                    ...buildAttachmentData(this.fileList),
                    prjLeaderId: this.prjLeaderList.map(i => i.userId).join(','),
                    prjLeaderName: this.prjLeaderList.map(i => i.name).join(','),
                    hostId: this.hostEmployee?.userId,
                    hostName: this.hostEmployee?.name,
                    recorderId: this.recorderId,
                    recorderName: this.recorderName,
                    attendeeIds: this.attendeeIds.join(','),
                    attendeeNames: this.attendeeNames,
                    majorLeaderIds: this.majorLeaderList.map(i => i.userId).join(','),
                    majorLeaderNames: this.majorLeaderList.map(i => i.name).join(','),
                };

                resubmitDesignReview(params)
                    .then(() => {
                        this.$close(this.$route.path, "/approval/task");
                    })
                    .catch((e) => {
                        console.error("提交失败详情", e);
                        this.$message.error("提交失败");
                    })
                    .finally(() => {
                        this.submitting = false;
                    });
            });
        },
        goBack() {
            this.$close(this.$route.path);
        },
    },
};
</script>

<style lang="less" scoped>
.container {
    background-color: #fff;
    padding: 24px 160px;
}

.center {
    margin-top: 80px;
    display: flex;
    justify-content: center;
}
</style>
